import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/homes/Home";
import ContactUs from "./pages/ContactUs";
import Dts from "./pages/homes/homepages/Dts";

import AboutRoutes from "./pages/About/AboutRoutes";
import DlashopRoutes from "./pages/Dlashops/dlashopRoutes";
import TradeRoutes from "./pages/Dlatrades/TradeRoutes";
import DentalRoutes from "./pages/DentalNews/DentalRoutes";
import MembersRoutes from "./pages/members/MembersRoutes";

// Dental Sidebar import
import DentalSidebar from "./pages/DentalNews/components/Sidebar";
import StoreCardsDisplay from "./pages/StoreCards";
import OnlinePaymentPage from "./pages/OnlinePayment";

function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  
  useEffect(() => {
    const header = document.getElementById("app-header");
    const updateHeight = () => {
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  // ✅ Dental Layout Component with Sidebar
  const DentalLayout = ({ children }) => {
    return (
      <div className="flex">
        {/* Sidebar - Desktop Only */}
        <div className="hidden lg:block w-72 xl:w-80 shrink-0 sticky top-52 h-screen overflow-y-auto bg-[#f7f9fc] border-r border-gray-200">
          <DentalSidebar />
        </div>
        
        {/* Content */}
        <div className="flex-1 min-h-screen">
          {children}
        </div>
      </div>
    );
  };

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />

        <main
          className="flex-grow transition-all duration-300"
          style={{ paddingTop: headerHeight }}
        >
          <Routes>
            {/* Normal Routes (Without Sidebar) */}
            <Route path="/" element={<Home />} />
            <Route path="/members/*" element={<MembersRoutes />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/dts-show" element={<Dts />} />

            <Route
              path="/dlashop/*"
              element={<DlashopRoutes isBasketMode={false} />}
            />
            <Route
              path="/basket/*"
              element={<DlashopRoutes isBasketMode={true} />}
            />

            {/* ✅ Dental Routes WITH Sidebar - Wrap DentalRoutes in DentalLayout */}
            <Route 
              path="/dental/*" 
              element={
                <DentalLayout>
                  <DentalRoutes />
                </DentalLayout>
              } 
            />
            
            {/* Other Routes (Without Sidebar) */}
            <Route path="/store" element={<StoreCardsDisplay />} />
             <Route path="/payment/*" element={<OnlinePaymentPage />} />
            <Route path="/dlatrade/*" element={<TradeRoutes />} />
            <Route path="/*" element={<AboutRoutes />} />
          </Routes>

          <Footer />
        </main>
      </div>
    </Router>
  );
}

export default App;